import create from 'zustand'

import { AddressInfo } from '@frame/ui-components/address/types'

import { FileStatusMap } from '@documents/types'
import { PayUnit } from '@frame/components/screens/tasks/screens/stated-information/types'

export type CachedEmploymentDetails = {
  start_date?: string
  end_date?: string
  job_title?: string
  employer_address?: AddressInfo
  employer_name?: string
  pay_unit?: PayUnit
  current_gross_base_pay?: string
  hours_worked_per_week?: string
}

type CachedEmploymentInfo = {
  [employerId: string]: {
    details: CachedEmploymentDetails
    files: File[]
    statusMap?: FileStatusMap
  }
}

type Store = {
  cachedEmploymentInfo: CachedEmploymentInfo
  saveFiles: (employerId: string, files: File[]) => void
  saveDetails: (employerId: string, details: Partial<CachedEmploymentDetails>) => void
  removeFile: (employerId: string, file: File) => void
  removeAllFiles: () => void
}

export const useCachedInfoStore = create<Store>((set) => ({
  cachedEmploymentInfo: {},
  removeFile: (employerId: string, file: File) =>
    set((state) => ({
      ...state,
      cachedEmploymentInfo: {
        ...state.cachedEmploymentInfo,
        [employerId]: {
          ...state.cachedEmploymentInfo[employerId],
          files: state.cachedEmploymentInfo[employerId]?.files?.filter((f) => f.name !== file.name),
        },
      },
    })),
  saveFiles: (employerId: string, files: File[]) =>
    set((state) => ({
      ...state,
      cachedEmploymentInfo: {
        ...state.cachedEmploymentInfo,
        [employerId]: {
          ...state.cachedEmploymentInfo[employerId],
          files: [...(state.cachedEmploymentInfo[employerId]?.files || []), ...files],
        },
      },
    })),
  saveDetails: (employerId: string, details: Partial<CachedEmploymentDetails>) => {
    if (!employerId) {
      return set((state) => state)
    }
    return set((state) => ({
      ...state,
      cachedEmploymentInfo: {
        ...state.cachedEmploymentInfo,
        [employerId]: {
          ...state.cachedEmploymentInfo[employerId],
          details: {
            ...state.cachedEmploymentInfo[employerId]?.details,
            ...details,
          },
        },
      },
    }))
  },
  removeAllFiles: () =>
    set((state) => ({
      ...state,
      cachedEmploymentInfo: {
        ...state.cachedEmploymentInfo,
        '': {
          details: {},
          files: [],
        },
      },
    })),
}))
